/**
 * @license
 * Copyright (c) 2021-present, FriendliAI Inc. All rights reserved.
 */

import { useSuspenseQuery } from '@apollo/client';
import { useParams } from 'react-router-dom';

import { DedicatedModelDetailHeaderDocument } from '@fai/friendli-suite/generated/client/graphql';

export const useModelDetailHeader = () => {
  const { modelId = '' } = useParams();

  const { data: _data } = useSuspenseQuery(DedicatedModelDetailHeaderDocument, {
    variables: { modelId },
    fetchPolicy: 'cache-and-network',
  });

  const data = {
    id: _data.dedicatedModel?.id,
    name: _data.dedicatedModel?.name,
  };

  return { data };
};

// FIXME: below are mocked hooks
export const useUpdateModelLabel = () => {
  // const [addLabelMutation] = useMutation(...)

  const addLabel = (value: string) => {
    // addLabelMutation(...);

    alert(`add label ${value}`);
  };

  // const [deleteLabelMutation] = useMutation(...)

  const deleteLabel = (value: string) => {
    // deleteLabelMutation(...);

    alert(`delete label ${value}`);
  };

  return { addLabel, deleteLabel };
};
